

const messages ={
        message:{
            about : 'About',
            home : 'Home',
            haveAccount :'I have a account',
            login:'Login',
            logout:'Log Out',
            mailAdress:'Mail Adress',
            password :'Password',
            passwordNumberReqiured : 'your password must consist of numbers',
            passwordMinMust : 'Your password must be at least ',
            passwordMaxMust : 'Your password must be at max ',
            passwordCharacters : 'characters ',
            passwordControl:'Must contain at least 3 characters',
            passwordSameAs:'Passwords are not the same',
            register :'Register',
            required :'This field is required',
            signIn :'Sign In',
            signUp:'Sign Up',
            validEmail :'please enter valid e-mail address',
        }
    }


export default messages